// resources/js/app/Components/Views/SubContracts/Mixins/SubContractStoreMixin.js
import { mapState, mapGetters } from 'vuex';

export const SubContractStoreMixin = {
    computed: {
        ...mapState('subContract', ['id','products','supplier','customer','shipping','schedule','accounting','forms']),
        ...mapGetters('subContract', ['subContractId']),
    },
    methods: {
        saveTab(tab, data) {
            this.$store.dispatch('subContract/saveTab', { tab, data: { ...data } });
        },
    },
};